<template>
  <div class="notfound">
    <img src="../assets/images/icon_blank.png" />
    <p class="text">页面不存在~</p>
  </div>
</template>
<script>
export default {

}
</script>

<style lang="less" scoped>
.notfound{
  height:100vh;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text{
    font-size:.32rem;
    line-height: .4rem;
    color: #999;
     margin-bottom: .68rem;
  }
  img {
    display: block;
    width:160px;
    height: 160px;
    margin-bottom: .32rem;
  }
}
</style>